// import AlliedCamera from '../../routes/SmartInspect/Warren/assets/maintenance/5.1-allied-camera.png';
// import AlliedConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.2-allied-camera-connections.png';
import ChannelBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.3-channel-board.png';
import LEDHeader from '../../routes/SmartInspect/Warren/assets/maintenance/5.4-LED-header-board.png';
import ArchDoubleWide from '../../routes/SmartInspect/Warren/assets/maintenance/5.5-arch-double-wide-LED.png';
import ArchBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.6-arch-light-boards.png';
import WideBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.7-LED-wide-light-boards.png';
import PDP from '../../routes/SmartInspect/Warren/assets/equipment/3.12-PDP.png';
// import ArchConnecions from '../../routes/SmartInspect/Warren/assets/maintenance/5.8-light-arch-connections.png';
// import DoubleWideConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.9-double-wide-connections.png';
// import TriggerBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.10-trigger-board-connections.png';
// import ArchHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.11-arch-light-housing.png';
// import DoubleHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.12-double-wide-housing.png';
import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					<h2 style={{ width: '50%', margin: 'auto' }}>
						Before replacing a channel board, make sure to first troubleshoot the issue in the <a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting">Channel Board Troubleshooting</a> section of this manual to ensure replacement is necessary.
					</h2>
				</BSCarousel.Caption>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					<p>
						Perform system power down/lock out as outlined in this manual and on the lock out placard located on the front of the <b>PDP</b>.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={PDP} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: PDP</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>

			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					<b></b>
					<p>Locate the appropriate light box that houses the channel board in need of replacement (see figures).</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
					<figure>
						<img className="d-block w-100" src={LEDHeader} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: LED Header Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={ArchDoubleWide} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: Arch/Double Wide LED Light Assemblies</figcaption>
					</figure>
				</div>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 3: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 4: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 4</h3>
					<p>Before removing the light box cover and or cables ensure the power is OFF.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					<p>Remove the associated power cable and trigger cable from the light box bulkhead by unscrewing the connector counter clockwise and pulling outward (see figures).</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
					<figure>
						<img className="d-block w-100" src={ArchBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 2: LED Arch Light/Channel Board Locations</figcaption>
					</figure>
				</div>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={WideBoards} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 3: LED Wide Light/Channel Board Locations</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					<p>Remove the two metric Allen screws that hold the light box cover in place and gently remove by pulling upward. This will give you access to the channel board and its associated connectors.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					<p>
						There are four connections on the channel board: The first is the larger two pin green power connector, the second is the smaller two pin green trigger connector, the third and fourth are the two black three pin LED board power VDC and ground GND connectors (see <b>Figure 1: Channel Board Connections</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 8</h3>
					<p>Remove all four connectors by grasping and pulling upward/outward.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 9</h3>
					<p>Remove the mounting screws from the board to remove the channel board assembly from the light box.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 10</h3>
					<p>Install the new channel board into the light box using the mounting screws removed in Step 9.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 11</h3>
					<p>Attach the power, trigger, LED board VDC/GND connectors back onto the channel board making note of the VDC and GND markings on the board. Make sure the LED board VDC/GND connectors are connected to the correct ports as an improper connection could cause damage to the channel/LED board.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 12</h3>
					<p>
						Ensure the new channel board has a fuse installed in the fuse holder (see <b>Figure 1: Channel Board Connections</b>).
					</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 13</h3>
					<p>Install the light box cover with the metric Allen screws that were removed in Step 6. Make sure not to pinch any of the wires while installing the cover.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 14</h3>
					<p>Connect the associated power and trigger cables back onto to the light box bulkhead ports by aligning the connector notch and screwing them in clockwise until fully seated. Make note of the labels on the bulkhead and ensure the correct cable goes to the associated port.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 15</h3>
					<p>Perform unlock procedure and restore power to the system.</p>
				</BSCarousel.Caption>
				<div class="modal-box" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={ChannelBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Channel Board Connections</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const ChannelBoardSMP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	.carousel-inner {
		border-radius: 2em;
		min-height: 50vh;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-caption {
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;

		& h3 {
			text-align: center;
		}
	}

	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default ChannelBoardSMP;
